import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-[#0f1d35]" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6" data-id="element-11">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-12">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-13">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-14">
              Kontakt
            </h2>

            <div className="space-y-8" data-id="element-15">
              <div className="flex items-start gap-4" data-id="element-16">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-17">
                  <MapPin size={24} data-id="element-18" />
                </div>
                <div data-id="element-19">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-20">
                    Adresa
                  </h3>
                  <p className="text-white/60" data-id="element-21">
                    <a href="https://aviatickyklubtlustice.cz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#38bdf8] transition-colors" data-id="element-22">
                      Aviatický klub Tlustice, z.s.
                    </a>
                    <br data-id="element-23" />
                    č.p. 258
                    <br data-id="element-24" />
                    268 01 Tlustice
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-25">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-26">
                  <Phone size={24} data-id="element-27" />
                </div>
                <div data-id="element-28">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-29">
                    Telefon (RADIO)
                  </h3>
                  <p className="text-white/60 hover:text-[#38bdf8] transition-colors cursor-pointer" data-id="element-30">
                    +420 606 730 374
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-31">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-32">
                  <Mail size={24} data-id="element-33" />
                </div>
                <div data-id="element-34">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-35">
                    E-mail
                  </h3>
                  <p className="text-white/60 hover:text-[#38bdf8] transition-colors cursor-pointer" data-id="element-36">
                    info@aviatickyklubtlustice.cz
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-37">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-38">
                  <Clock size={24} data-id="element-39" />
                </div>
                <div data-id="element-40">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-41">
                    Provozní doba
                  </h3>
                  <p className="text-white/60" data-id="element-42">Nestanovena pevně (O/R)</p>
                  <p className="text-white/60" data-id="element-43">
                    Pouze po dohodě s provozovatelem
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[400px] w-full" data-id="element-44">
            <a href="https://mapy.com/cs/turisticka?q=N49%C2%B050%E2%80%9953%2C00%E2%80%9D%20E013%C2%B053%E2%80%9938%2C00%E2%80%9D&source=coor&id=13.893888888888888%2C49.84805555555556&ds=2&x=13.8911369&y=49.8486886&z=15" target="_blank" rel="noopener noreferrer" className="block h-full w-full bg-[#0a1628] rounded-2xl border border-white/10 relative overflow-hidden group cursor-pointer hover:border-[#38bdf8]/40 transition-colors" data-id="element-45">
              {/* Map Placeholder Visuals */}
              <div className="absolute inset-0 bg-[#0f1d35] opacity-50" data-id="element-46" />
              <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-47">
                <div className="w-16 h-16 bg-[#38bdf8]/20 rounded-full flex items-center justify-center mb-4 backdrop-blur-sm group-hover:scale-110 transition-transform duration-300" data-id="element-48">
                  <MapPin size={32} className="text-[#38bdf8]" data-id="element-49" />
                </div>
                <h3 className="text-white font-bold text-xl mb-2" data-id="element-50">
                  Interaktivní mapa
                </h3>
                <p className="text-white/50 text-sm" data-id="element-51">
                  Klikněte pro otevření navigace
                </p>
              </div>

              {/* Grid lines for "map" feel */}
              <div className="absolute inset-0 pointer-events-none" style={{
              backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)',
              backgroundSize: '40px 40px'
            }} data-id="element-52" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}